import { defineStore } from 'pinia';
import http from '../api/httpRequest.js'
import { RTC_STATE } from "../api/enums.js"

export default defineStore('userStore', {
	state: () => {
		return {
			userInfo: {},
			isInRtc: false // 是否正在通话中
		}
	},
	getters: {
		hasPermission: (state) => (code) => Array.isArray(state.userInfo.permissions) && state.userInfo.permissions.includes(code)
	},
	actions: {
		setUserInfo(userInfo) {
			this.userInfo = userInfo
		},
		setInRtc(isInRtc) {
			this.isInRtc = isInRtc;
		},
		clear() {
			this.userInfo = {};
			this.rtcInfo = {
				friend: {},
				mode: "video",
				state: RTC_STATE.FREE
			};
		},
		async loadUser() {
			const userInfo = await http({ url: '/user/self' });
			this.setUserInfo(userInfo);
			if (userInfo.deleted || userInfo.isBanned) {
				throw new Error("账户已注销或被封禁")
			}
		}
	}
});
